import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import PLink from "@/components/PLink";

// Mobile-only: replaces the horizontally-scrolling link row with a tap-to-open menu.
export const MobileMenu = ({ links, cta }) => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname]);
  const current = links.find((l) => l.to === loc.pathname) || (loc.pathname === "/dashboard" ? { label: "Home" } : null);
  return (
    <div className="xl:hidden border-t border-white/10" data-testid="mobile-menu">
      <button onClick={() => setOpen((o) => !o)} aria-expanded={open} className="w-full flex items-center justify-between px-4 py-2.5 text-xs uppercase tracking-widest font-semibold text-white" data-testid="mobile-menu-toggle">
        <span className="flex items-center gap-2">{open ? <X className="w-4 h-4 text-[#FF6A00]" /> : <Menu className="w-4 h-4 text-[#FF6A00]" />} {open ? "Close" : current?.label || "Menu"}</span>
        <ChevronDown className={`w-4 h-4 text-zinc-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="border-t border-white/10 bg-[#0A0A0A] px-2 pb-3 pt-1" data-testid="mobile-menu-panel">
          {links.map((l) => (
            <PLink key={l.to} to={l.to} className={`block px-3 py-3 text-sm uppercase tracking-widest font-semibold border-b border-white/5 ${loc.pathname === l.to ? "text-[#FF6A00]" : "text-zinc-300"}`} data-testid={l.testid}>{l.label}</PLink>
          ))}
          {cta && <PLink to={cta.to} className="mt-3 flex items-center justify-center gap-1 px-3 py-3 bg-[#FF6A00] text-black text-xs font-black uppercase tracking-widest" data-testid={cta.testid}>{cta.label}</PLink>}
        </div>
      )}
    </div>
  );
};
